import type { LockIcon } from 'types/graphql-base'
import { ExternalSystemFieldDataType } from './enums'

export interface PageInfo {
  endCursor?: string | null
  hasNextPage?: boolean | null
  hasPreviousPage?: boolean | null
}

export interface PageInfo2 extends PageInfo {
  startCursor?: string | null
}

export interface Lock {
  id: string
  icon: LockIcon
  name: string
  description: string
  location: {
    name: string
  }
}

export interface AccessProfile {
  id: string
  name: string
  description?: string | null
  viewerGranteeAccessDateTimeRangeRequired?: boolean | null
}

export interface User {
  id: string
  email?: string | null
  name?: string | null
}

export interface AccessCode {
  id: string
  name: string | null
  code: string
  viewerCanRemove: boolean
  accessDateTimeRange?: {
    start: string
    end: string
  }
  usageLimit: number | null
}

export interface ExternalSystemField {
  value: string | null
  node: {
    id: string
    title: string
    summary: string
    dataType: ExternalSystemFieldDataType
    regexPattern: string
  }
}

export interface AccessCustomCredentialsField {
  value: string | null
  node: {
    id: string
    title: string
    summary: string
  }
}

export interface CreditAccount {
  id: string
  creditBalance: number
}

export enum DelegatedAccountProvider {
  GOOGLE = 'GOOGLE',
}

export type ApiLockObject = { lockId: string; optionIds: string[] | null }
